// extracted by mini-css-extract-plugin
module.exports = {"h6":"h6__9lLXi","p":"p__h08br","event":"event__IJ0kz","eventDetail":"eventDetail__J8+ol","eventIcon":"eventIcon__h5MIB","eventTime":"eventTime__LA54j"};